<div class="pnl-settings-parameter">
  <header>
    <a [routerLink]="['/app/configuracao']" class="back">Configurações</a>
    <h1>Parâmetros do site</h1>
  </header>

  <form [formGroup]="settingsFrm" (ngSubmit)="onSubmit()" novalidate>
    <section>
      <div>
        <strong>Padrão</strong>

        <div class="form-col">
          <label>Título</label>
          <div class="row">
            <input
              name="title"
              formControlName="title"
              class="form-control"
              (keyup)="onChangeDetail()"
            />
          </div>
        </div>

        <div class="form-col">
          <label>Keywords</label>
          <div class="row">
            <input
              name="keywords"
              formControlName="keywords"
              class="form-control"
              (keyup)="onChangeDetail()"
            />
          </div>
        </div>

        <div class="form-col">
          <label>Descrição</label>
          <div class="row">
            <input
              name="description"
              formControlName="description"
              class="form-control"
              (keyup)="onChangeDetail()"
            />
          </div>
        </div>
      </div>

      <div>
        <strong>Redes sociais</strong>

        <div class="grid" formArrayName="networksocial">
          <div class="row header mt10">
            <div class="col">
              <label>Rede social</label>
            </div>
            <div class="col">
              <label>Endereço (Url)</label>
            </div>
            <div class="col actions"></div>
          </div>
          <div
            class="row"
            *ngFor="
              let grp_networksocial of networksocial.controls;
              let i = index
            "
            [formGroupName]="i"
            [class.dnone]="grp_networksocial.controls.social.value == -1"
          >
            <div class="col">
              <ng-select
                [items]="networksocials"
                (change)="onChangeDetail()"
                formControlName="social"
                (clear)="onChangeDetail()"
                placeholder="Selecione"
                bindLabel="text"
                bindValue="value"
              >
                <ng-template ng-label-tmp ng-option-tmp let-item="item">
                  <div class="ng-select-payment">
                    <fa-icon *ngIf="item.fa" [icon]="item.fa"></fa-icon>
                    {{ item.text }}
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <div class="col">
              <input
                type="text"
                formControlName="url"
                class="form-control"
                (keyup)="onChangeDetail()"
              />
            </div>
            <div class="col actions">
              <a (click)="onRemoveNetworkSocial(i)" class="btn-close-round"></a>
            </div>
          </div>
          <div class="row">
            <button
              (click)="onAddNewNetworkSocial(undefined)"
              type="button"
              class="btn btn-green-outline"
            >
              <span>
                <i class="btn-add-round"></i>
                <span>Adicionar nova rede social</span>
              </span>
            </button>
          </div>
        </div>
      </div>

      <div>
        <strong>Configuração</strong>

        <div class="row">
          <div class="form-col f1 mr5">
            <label>Números de produtos por página</label>
            <div class="row">
              <input
                name="nr_product_page"
                formControlName="nr_product_page"
                class="form-control"
                mask="separator.0"
                thousandSeparator=""
                maxlength="2"
                (keyup)="onChangeDetail()"
              />
            </div>
          </div>

          <div class="form-col f1 ml5 mr5">
            <label>Números de produtos recomendado</label>
            <div class="row">
              <input
                name="nr_product_recommended"
                formControlName="nr_product_recommended"
                class="form-control"
                mask="separator.0"
                thousandSeparator=""
                maxlength="2"
                (keyup)="onChangeDetail()"
              />
            </div>
          </div>

          <div class="form-col f1 ml5">
            <label>Números de ofertas em destaque</label>
            <div class="row">
              <input
                name="nr_offers"
                formControlName="nr_offers"
                class="form-control"
                mask="separator.0"
                thousandSeparator=""
                maxlength="2"
                (keyup)="onChangeDetail()"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-col f1 mr5">
            <label>Chat Whatsapp (ex: 551199009900)</label>
            <div class="row">
              <input
                name="chat_whatsapp"
                formControlName="chat_whatsapp"
                class="form-control"
                mask="000000000000||0000000000000"
                (keyup)="onChangeDetail()"
              />
            </div>
          </div>

          <div class="form-col f1 ml5 mr5">
            <label>Texto oferta</label>
            <div class="row">
              <input
                name="text_offers"
                formControlName="text_offers"
                class="form-control"
                (keyup)="onChangeDetail()"
              />
            </div>
          </div>

          <div class="form-col f1 ml5">
            <label>Texto departamento</label>
            <div class="row">
              <input
                name="text_department"
                formControlName="text_department"
                class="form-control"
                (keyup)="onChangeDetail()"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-col f1 mr5">
            <label>Texto drivethru</label>
            <div class="row">
              <input
                name="text_drivethru"
                formControlName="text_drivethru"
                class="form-control"
                (keyup)="onChangeDetail()"
              />
            </div>
          </div>

          <div class="form-col f2 ml5">
            <label>Texto drivethru descritivo</label>
            <div class="row">
              <input
                name="text_drivethru_description"
                formControlName="text_drivethru_description"
                class="form-control"
                (keyup)="onChangeDetail()"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-col f1 mr5">
            <label>Texto delivery</label>
            <div class="row">
              <input
                name="text_delivery"
                formControlName="text_delivery"
                class="form-control"
                (keyup)="onChangeDetail()"
              />
            </div>
          </div>

          <div class="form-col f2 ml5">
            <label>Texto delivery descritivo</label>
            <div class="row">
              <input
                name="text_delivery_description"
                formControlName="text_delivery_description"
                class="form-control"
                (keyup)="onChangeDetail()"
              />
            </div>
          </div>
        </div>

        <div class="row mt10">
          <div class="form-col f1 mr5">
            <mat-checkbox
              id="show_brands"
              formControlName="show_brands"
              (change)="onChangeDetail()"
              >Mostrar filtro marcas</mat-checkbox
            >
          </div>

          <div class="form-col f1 ml5 mr5">
            <mat-checkbox
              id="menu_fixed"
              formControlName="menu_fixed"
              (change)="onChangeDetail()"
              >Cabeçalho fixo</mat-checkbox
            >
          </div>

          <div class="form-col f1 ml5">
            <mat-checkbox
              id="dynamic_price"
              formControlName="dynamic_price"
              (change)="onChangeDetail()"
              >Preço dinâmico</mat-checkbox
            >
          </div>
        </div>

        <div class="row mt10">
          <div class="form-col f1 mr5">
            <mat-checkbox
              id="warning_cookies"
              formControlName="warning_cookies"
              (change)="onChangeDetail()"
              >Aviso de cookies</mat-checkbox
            >
          </div>

          <div class="form-col f1 ml5 mr5">
            <mat-checkbox
              id="warning_drinking"
              formControlName="warning_drinking"
              (change)="onChangeDetail()"
              >Aviso de bebidas</mat-checkbox
            >
          </div>

          <div class="form-col f1 ml5">
            <mat-checkbox
              id="mostra_estoque"
              formControlName="mostra_estoque"
              (change)="onChangeDetail()"
              >Mostrar estoque</mat-checkbox
            >
          </div>
        </div>

        <div class="form-col">
          <label>Aviso de mensagem de cookies</label>
          <div class="row">
            <textarea
              formControlName="warning_cookies_message"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              class="form-control"
              (keyup)="onChangeDetail()"
            ></textarea>
          </div>
        </div>
      </div>

      <div>
        <strong>Scripts</strong>

        <div class="form-col">
          <label>Analytics code</label>
          <div class="row">
            <textarea
              formControlName="analytics_code"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              class="form-control"
              (keyup)="onChangeDetail()"
            ></textarea>
          </div>
        </div>

        <div class="form-col">
          <label>Código na tag Header</label>
          <div class="row">
            <textarea
              formControlName="code_header"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              class="form-control"
              (keyup)="onChangeDetail()"
            ></textarea>
          </div>
        </div>

        <div class="form-col">
          <label>Código na tag Body</label>
          <div class="row">
            <textarea
              formControlName="code_body"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              class="form-control"
              (keyup)="onChangeDetail()"
            ></textarea>
          </div>
        </div>
      </div>
    </section>
  </form>

  <div class="actions" [class.dflex]="changed">
    <span>Salvar as alterações</span>
    <div>
      <button
        type="button"
        (click)="onCancel()"
        class="btn btn-primary-outline"
      >
        Cancelar
      </button>
      <button type="button" (click)="onSubmit()" class="btn btn-primary">
        Salvar
      </button>
    </div>
  </div>

  <div class="loading" *ngIf="loading">
    <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
      <div class="ldio-ns36390yc">
        <div></div>
      </div>
    </div>
  </div>
</div>
